import React from "react";
import Routes from "./Routes";
import { LanguageProvider } from "./hooks/useLanguage";
import { ToastProvider } from "./components/ui/Toast";

function App() {
  return (
    <LanguageProvider>
      <ToastProvider>
        <Routes />
      </ToastProvider>
    </LanguageProvider>
  );
}

export default App;
